module.exports = new __parcel__URL__("bikeTour.2f2ae079.jpg").toString();